import React from "react";
import { ModalsProviderContextTypes } from "./ModalsProvider.types";

export const ModalsProviderContext =
    React.createContext<ModalsProviderContextTypes>({} as ModalsProviderContextTypes);
 
